import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CircleAlertIcon from "../../Icons/CircleAlertIcon";
import "./PopupNotification.css";

const PopupNotification = () => {
  const [isVisible, setIsVisible] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (isVisible) {
      document.addEventListener("click", handler, true);
      document.getElementById("notification-div").style.visibility = "visible";
    }

    if (!isVisible) {
      setTimeout(() => {
        document.getElementById("notification-div").style.visibility = "hidden";
      }, 200);
    }

    return () => document.removeEventListener("click", handler, true);
  }, [isVisible]);

  const handler = (e) => {
    if (e.target.id !== "notificationDismiss") {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return (
    <div
      id="notification-div"
      className={`popup-notification ${isVisible ? "show" : "hide"}`}
    >
      <div className="popup-notification-icon">
        <CircleAlertIcon />
      </div>
      <div className="popup-notification-text notification-text-size ">
        {t("notificationWarningMsg")}
      </div>
      <a
        className="notification-text-size dismiss-button"
        id="notificationDismiss"
        onClick={() => {
          document.removeEventListener("click", handler, true);
          setIsVisible(false);
        }}
      >
        {t("dismiss")}
      </a>
    </div>
  );
};

export default PopupNotification;
